// extracted by mini-css-extract-plugin
module.exports = {"root":"EditListingAboutThisServicePanel_root__2BRFo","form":"EditListingAboutThisServicePanel_form__2TfHo","title":"EditListingAboutThisServicePanel_title__1n5Ae"};